import * as Cookie from './cookie';

export function setContrast(value) {
    document.querySelector('body').setAttribute('data-contrast-mode', value);
    Cookie.set('contrast', value, 43800);
}

export function toggleContrast() {
    const contrast = Cookie.get('contrast');
    switch (contrast) {
    case 'high':
        return setContrast('low');
    default:
        return setContrast('high');
    }
}

export default function initContrastMode() {
    document.querySelectorAll('[data-set-contrast]')
        .forEach((trigger) => {
            const contrast = trigger.getAttribute('data-set-contrast');
            switch (contrast) {
            case 'toggle':
                return trigger.addEventListener('click', () => toggleContrast());
            default:
                return trigger.addEventListener('click', () => setContrast(contrast));
            }
        });

    setContrast(Cookie.get('contrast'));
}
